/** Every part kind the bench knows, registered once. */
import { registerKind } from '../registry';
import { anchor } from './anchor';
import { sheave } from './sheave';
import { weight } from './weight';
import { ropeEnd } from './ropeEnd';
import { springBalance } from './springBalance';
import { incline, table } from './surface';

let done = false;

/** Idempotent: importing the engine twice must not double-register. */
export function registerBuiltInKinds(): void {
    if (done) return;
    done = true;
    [anchor, sheave, weight, ropeEnd, table, incline, springBalance].forEach(k => registerKind(k as never));
}

export { anchor, sheave, weight, ropeEnd, table, incline, springBalance };
export { ANCHOR_EYE } from './anchor';
export { weightHalf, WEIGHT_HALF_W, WEIGHT_HALF_MIN, WEIGHT_HALF_MAX, WEIGHT_ON_FACE_HALF } from './weight';
export { corners, apexHeight } from './surface';
export { BALANCE_HALF } from './springBalance';
export type { AnchorData } from './anchor';
export { SHEAVE_R, SHEAVE_R_MIN, SHEAVE_R_MAX, SHEAVE_R_ON_FACE, wrapOf } from './sheave';
export type { SheaveData } from './sheave';
export type { WeightData } from './weight';
export type { RopeEndData } from './ropeEnd';
export type { SurfaceData } from './surface';
export type { SpringBalanceData } from './springBalance';
